export const modifiers = {
    amex: 'amex',
    mastercard: 'mastercard',
    paypal: 'paypal',
    visa: 'visa',
};
